import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios } from "./axiosActions";

export const initialState = {
   loading: false,
   hasErrors: false,
   scanReport: [],
};

const localFalconSlice = createSlice({
   name: 'localFalcon',
   initialState,
   reducers: {
      getScanReport: state => {
         state.loading = true;
      },
      getScanReportSuccess: (state, { payload }) => {
         state.scanReport = payload ?? [];
         state.loading = false;
         state.hasErrors = false;
      },
      getScanReportFailure: state => {
         state.loading = false;
         state.hasErrors = true;
      },
      scanLocation: state => {
         state.loading = true;
      },
      scanLocationSuccess: (state, { payload }) => {
         state.scanReport = payload ?? [];
         state.loading = false;
         state.hasErrors = false;
      },
      scanLocationFailure: state => {
         state.loading = false;
         state.hasErrors = true;
      },
   },
});

export const { getScanReport, getScanReportSuccess, getScanReportFailure,
   scanLocation, scanLocationSuccess, scanLocationFailure } = localFalconSlice.actions;
export const localFalconSelector = state => state.localFalcon;
export default localFalconSlice.reducer;
export function getScanReportData(sourceId) {

   return async dispatch => {
      dispatch(getScanReport());
      try {
         const params = { callTime: new Date() };
         const data = await getAxios('api/LocalFalcon/GetScanReport?sourceId=' + sourceId, { params: params });
         dispatch(getScanReportSuccess(data));

      } catch (error) {
         dispatch(getScanReportFailure());
      }
   };
}
export function scanLocationData(input) {

   return async dispatch => {
      dispatch(scanLocation());
      try {
         const params = { callTime: new Date() };
         const data = await postAxios('api/LocalFalcon/ScanLocation', { params: input });
         dispatch(scanLocationSuccess(data));
         dispatch(getScanReportData(input.sourceId));

      } catch (error) {
         dispatch(scanLocationFailure());
      }
   };
}

